module.exports = __webpack_public_path__ + "img/icon_lazer.c9693506.svg";